import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const datetimeInputV3Migration: PropsMigration = {
  mode: 'props',
  description:
    'Migrate Datetime Input element to v3 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'datetimeInput'>): void => {
    const datetimeInputProps = props;

    if (
      datetimeInputProps?.style?.general?.title &&
      !datetimeInputProps?.content?.title?.iconColor
    ) {
      const currentColor = datetimeInputProps.style.general.title.color1;
      datetimeInputProps.content = {
        ...datetimeInputProps.content,
        title: {
          ...datetimeInputProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
